export default __webpack_public_path__ + "924e8b14b26663be3642d110d4561453.png";